import { ref } from 'vue'

function createToastToggle() {
  const show = ref(false)
  let isProcessing = false

  const set = () => {
    if (isProcessing) return
    isProcessing = true
    show.value = true
  }

  const clear = () => {
    show.value = false
  }

  const reset = () => {
    isProcessing = false
    show.value = false
  }

  return { show, set, clear, reset }
}

const unauthenticated = createToastToggle()
export const showUnauthenticatedToast = unauthenticated.show
export const setUnauthenticatedToast = unauthenticated.set
export const clearToastRef = unauthenticated.clear
export const resetUnauthenticatedState = unauthenticated.reset

const noValidClient = createToastToggle()
export const showNoValidClientToast = noValidClient.show
export const setNoValidClientToast = noValidClient.set
export const clearNoValidClientToastRef = noValidClient.clear
export const resetNoValidClientToast = noValidClient.reset
